import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/app/[locale]/template.tsx");
